import styled from 'styled-components';
import { layout, media } from '@prisjakt/ui-base';
import { DropdownToggle as DropdownToggleComponent } from '@prisjakt/ui/dropdown';
import { ButtonText } from '@prisjakt/ui/button';
import ModalComponent from 'src/components/modal';

export const MediumUpDevice = styled.div`
  max-width: 100%;
  width: min-content; /* needed for the clickOutside event when closing the dropdown */

  ${media.smallOnly`
    display: none;

  `}
`;

export const SmallOnlyDevice = styled.div`
  ${media.mediumUp`
    display: none;
  `}
`;

export const VariantGridWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: ${layout.measurements.spacing050};

  ${media.mediumUp`
    padding: 0 ${layout.measurements.spacing050};
    grid-template-columns: repeat(5, min-content);
  `}
`;

export const VariantGridCell = styled.div`
  min-width: 62px;
  padding: 1px;
`;

export const VariantGridTitle = styled.div`
  grid-column: span 4;
  margin-bottom: ${layout.measurements.spacing050};
`;

export const DropdownToggle = styled(DropdownToggleComponent)`
  width: auto;
  min-width: 206px;
`;

export const DropdownButtonText = styled(ButtonText)`
  text-align: left;
`;

export const SelectionButtonText = styled(ButtonText)`
  max-width: 100px;
`;

export const Modal = styled(ModalComponent)`
  && {
    padding: ${layout.measurements.spacing150};
    width: 100vw;
    max-width: 100vw;
    min-height: 25vh;
    bottom: 0;
    margin: 0;
  }
`;
